var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.date)?_c('div',{staticClass:"country-notice"},[_c('span',[_vm._v("@ 2020 H·ROBOTICS All Rights Reserved.")]),(_vm.country)?_c('span',[_vm._v(_vm._s(_vm.country))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }